import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import api, { handleApiError } from '../../helpers/api';
import {
    fetchTeamDataSuccess,
    fetchTeamDataFailure,
    addTeamDataSuccess,
    addTeamDataFailure,
 updateTeamDataSuccess,
    updateTeamDataFailure,
    deleteTeamDataSuccess,
    deleteTeamDataFailure,
    toggleActiveSuccess,
    toggleActiveFailure,
} from './action';
import {
    FETCH_TEAM_DATA_REQUEST,
    ADD_TEAM_DATA_REQUEST,
    UPDATE_TEAM_DATA_REQUEST,
    DELETE_TEAM_DATA_REQUEST,
    TOGGLE_ACTIVE_REQUEST,
} from './actionType';

// Saga to fetch team data
function* fetchTeamData({ payload: { dispatch, navigate } }) {
    try {
        const response = yield call(api.get, '/user');
        const teamData = response.data.users.map((user) => ({
            id: user._id,
            firstname: user.firstname,
            lastname: user.lastname,
            phoneNumber: user.phoneNumber,
            email: user.email,
            role: user.role,
            isActive: user.active,
            twoFactorEnabled: user.twoFactorEnabled,
        }));
        yield put(fetchTeamDataSuccess(teamData));
    } catch (error) {
        yield put(fetchTeamDataFailure(error.message));
        yield call(handleApiError, error, dispatch, navigate);
    }
}

// Saga to add team data
function* addTeamData({ payload: { data, dispatch, navigate } }) {
    try {
        const response = yield call(api.post, '/user', data, {
            withCredentials: true,
        });
        if (response.status === 201 || response.status === 200) {
            const newUser = {
                id: response.data.user._id,
                firstname: response.data.user.firstname,
                lastname: response.data.user.lastname,
                phoneNumber: response.data.user.phoneNumber,
                email: response.data.user.email,
                role: response.data.user.role,
                isActive: response.data.user.active,
                twoFactorEnabled: response.data.user.twoFactorEnabled,
            };
            message.success('Team member added successfully');
            yield put(addTeamDataSuccess(newUser));
        } else {
            message.error('Phone number or email already exists');
            yield put(addTeamDataFailure('Phone number or email already exists'));
        }
    } catch (error) {
        message.error('Phone number or email already exists');
        yield put(addTeamDataFailure(error.message));
        yield call(handleApiError, error, dispatch, navigate);
    }
}

// Saga to update team data
function* updateTeamData({ payload: { id, data, dispatch, navigate } }) {
    try {
        const response = yield call(api.patch, `/user/${id}`, data, {
            withCredentials: true,
        });
        if (response.status === 200) {
            const updatedUser = {
                _id: id,
                ...response.data.user,
            };
            message.success('Team member updated successfully');
            yield put(updateTeamDataSuccess(updatedUser));
        } else {
            message.error('Failed to update team member');
            yield put(updateTeamDataFailure('Failed to update team member'));
        }
    } catch (error) {
        message.error('Error updating team member');
        yield put(updateTeamDataFailure(error.message));
        yield call(handleApiError, error, dispatch, navigate);
    }
}

// Saga to delete team data
function* deleteTeamData({ payload: { id, dispatch, navigate } }) {
    try {
        const response = yield call(api.delete, `/user/${id}`, {
            withCredentials: true,
        });
        if (response.status === 200 || response.status === 204) {
            message.success('Team member deleted successfully');
            yield put(deleteTeamDataSuccess({ id }));
        } else {
            message.error('Failed to delete team member');
            yield put(deleteTeamDataFailure('Failed to delete team member'));
        }
    } catch (error) {
        message.error('Error deleting team member');
        yield put(deleteTeamDataFailure(error.message));
        yield call(handleApiError, error, dispatch, navigate);
    }
}

// Saga to toggle active status
function* toggleActive({ payload: { id, isActive, dispatch, navigate } }) {
    try {
        const response = yield call(api.patch, `/user/${id}`, { active: isActive }, {
            withCredentials: true,
        });
        if (response.status === 200) {
            message.success('Team member status updated successfully');
            yield put(toggleActiveSuccess(id, isActive));
        } else {
            message.error('Failed to update team member status');
            yield put(toggleActiveFailure('Failed to update team member status'));
        }
    } catch (error) {
        message.error('Error toggling team member status');
        yield put(toggleActiveFailure(error.message));
        yield call(handleApiError, error, dispatch, navigate);
    }
}

// Root saga
export default function* teamSaga() {
    yield takeEvery(FETCH_TEAM_DATA_REQUEST, fetchTeamData);
    yield takeEvery(ADD_TEAM_DATA_REQUEST, addTeamData);
    yield takeEvery(UPDATE_TEAM_DATA_REQUEST, updateTeamData);
    yield takeEvery(DELETE_TEAM_DATA_REQUEST, deleteTeamData);
    yield takeEvery(TOGGLE_ACTIVE_REQUEST, toggleActive);
}